import $ from "jquery";
import * as Common from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";

export default function standart() {}

export async function fillDetail(result) {
  if (result !== undefined) {
    if (result && result.data.content.algemeen.prijs === undefined) {
      $("#d-algemeen-prijs").html("");
    } else $("#d-algemeen-prijs").html(result.data.content.algemeen.prijs);
    $("#e-algemeen-prijs").val(result.data.content.algemeen.prijs);
  }

  $("#d-algemeen-naam").html(
    window.$catalog_work_resources_selectedRow.algemeenNaam
  );
  $("#d-algemeen-naam-tooltip").html(
    window.$catalog_work_resources_selectedRow.algemeenNaam
  );
  $("#d-algemeen-code").html(
    window.$catalog_work_resources_selectedRow.algemeenCode
  );
  $("#d-algemeen-omschrijving").html(
    window.$catalog_work_resources_selectedRow.omschrijving
  );
  $("#d-algemeen-omschrijving-tooltip").html(
    window.$catalog_work_resources_selectedRow.omschrijving
  );
  $("#d-algemeen-kosteneenheid").html(
    window.$catalog_work_resources_selectedRow.kosteneenheid
  );

  if (window.$catalog_work_resources_selectedRow.isActive)
    $("#work_resources_active").attr("checked", "checked");
  else $("#work_resources_active").removeAttr("checked");
  $("#d-timestamp_created").attr(
    "placeholder",
    window.$catalog_work_resources_selectedRow.datumAangemaakt
  );
  $("#d-timestamp_any_update").attr(
    "placeholder",
    window.$catalog_work_resources_selectedRow.datumLaatstGewijzigd
  );

  //editSide
  $("#e-algemeen-naam").val(
    window.$catalog_work_resources_selectedRow.algemeenNaam
  );
  $("#e-algemeen-code").val(
    window.$catalog_work_resources_selectedRow.algemeenCode
  );
  $("#e-algemeen-omschrijving").val(
    window.$catalog_work_resources_selectedRow.omschrijving
  );
  $("#e-algemeen-kosteneenheid-select").val(
    window.$catalog_work_resources_selectedRow.kosteneenheid
  );

  var kosteneenheid = $("#e-algemeen-kosteneenheid");
  kosteneenheid[0].childNodes.forEach((element) => {
    element.textContent ==
    window.$catalog_work_resources_selectedRow.kosteneenheid
      ? (element.className = "popuptext-dropdown-a-selected")
      : (element.className = "popuptext-dropdown-a");
  });

  if (window.$catalog_work_resources_selectedRow.isActive)
    $("#e-work_resources_active").attr("checked", "checked");
  else $("#e-work_resources_active").removeAttr("checked");
  $("#e-identification").val(
    window.$catalog_work_resources_selectedRow.identification
  );
}

export function GetColumnProperties(callType) {
  omnimap
    .GetColumnPropertiesAction(window.$catalog_management_units_token)
    .then((result) => {
      CallBackFunctions.GetColumnPropertiesCallBack(result, callType);
      fillDetail();
    });
}
export function GetColumnPropertiesForModel(
  model,
  pageNr,
  pageSize,
  callType,
  itemId,
  token
) {
  omnimap
    .OmnimapPost(model, pageNr, pageSize, token)
    .then((result) => {
      CallBackFunctions.GetColumnPropertiesForModelCallBack(
        result,
        itemId,
        callType
      );
    })
    .catch((error) => {
      console.log(error);
    });
}

export function GetRowOfDetail(row_id) {
  omnimap
    .GetRowOfDetailAction(row_id, window.$catalog_management_units_token)
    .then(fillDetail);
}

export const rowsHandleDelete = () => {
  window.$catalog_work_resources_selectedIds.forEach((element) =>
    omnimap
      .Delete(element, window.$catalog_management_units_token)
      .then((result) => {
        CallBackFunctions.RowsDeletedCallBack(
          window.$catalog_management_units_token
        );
      })
      .catch((error) => {
        console.log(error);
      })
  );
};
